import {
  IncidentStrategy,
  useIncidentStrategies,
} from './hooks/incidentStrategyHooks';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { SharedIcon } from '../SharedIcon/SharedIcon';
import EntityList from './EntityList';
import { useToggle } from 'react-use';
import { Card } from 'react-bootstrap';
import { useState } from 'react';
import classNames from 'classnames';
import StrategyAddDrawer from './StrategyAddDrawer';
import StrategyEditDrawer from './StrategyEditDrawer';
import { IapScope, INCIDENT, ORGANIZATION } from './ICSConstants';

import { MdEdit } from 'react-icons/md';
import { useStrategies, Strategy } from './hooks/strategyHooks';

type StrategyEntity = IncidentStrategy | Strategy;

const CollapsibleStrategiesList = ({
  scope = INCIDENT,
}: {
  scope?: IapScope;
}) => {
  const [expanded, toggleExpanded] = useToggle(false);
  const [editOpen, toggleEditDrawer] = useToggle(false);
  const [addOpen, toggleAddDrawer] = useToggle(false);
  const [selectedEntity, setSelectedEntity] = useState<StrategyEntity | null>(
    null
  );

  const { data: incidentStrategies } = useIncidentStrategies(scope);
  const isEnabled = scope === ORGANIZATION;
  const { data: organizationStrategies } = useStrategies(isEnabled);

  const isIncident = scope === INCIDENT;
  const entities = isIncident ? incidentStrategies : organizationStrategies;

  const selectElement = (element: StrategyEntity) => {
    setSelectedEntity(element);
    toggleEditDrawer();
  };

  return (
    <>
      <EntityList
        entities={entities}
        expanded={expanded}
        toggleExpanded={toggleExpanded}
        header={
          <div className="d-flex align-items-center justify-content-between flex-grow-1">
            <span>{`${isIncident ? 'Incident' : 'Organization'} Strategies`}</span>
            <StylishNewButton
              className={classNames('button', {
                'button--primary': expanded,
                'button--secondary': !expanded,
              })}
              onClick={toggleAddDrawer}
            >
              <SharedIcon iconName="add" classes="me-2" />
              Add
            </StylishNewButton>
          </div>
        }
        renderEntity={(element) => (
          <Card
            key={element.id}
            className="bg-neutral-800 my-1 rounded-1 flex-row align-items-center justify-content-between"
            style={{
              padding: '0.625rem 1rem 0.625rem 1rem',
            }}
          >
            <span>{element.name}</span>
            <StylishNewButton
              className="button button--link"
              onClick={() => selectElement(element)}
            >
              <MdEdit />
            </StylishNewButton>
          </Card>
        )}
      ></EntityList>
      {addOpen ? (
        <StrategyAddDrawer toggle={toggleAddDrawer} scope={scope} />
      ) : null}
      {editOpen && selectedEntity ? (
        <StrategyEditDrawer
          toggle={toggleEditDrawer}
          selectedEntity={selectedEntity}
          scope={scope}
        />
      ) : null}
    </>
  );
};

export default CollapsibleStrategiesList;
